<!--
 * @Descripttion: 
 * @version: 0.1.0
 * @Author: wangcan
 * @Date: 2023-02-16 10:56:33
 * @LastEditors: wangcan
 * @LastEditTime: 2023-10-12 17:47:08
-->
<template>
  <div class="send-add-mobile">
    <div class="come-back-wrap">
      <van-nav-bar left-arrow @click-left="goBack" title="投递简历" />
    </div>
    <van-form @submit="dataFormSubmit">
      <van-field
        v-model="dataForm.name"
        name="姓名"
        label="姓名"
        placeholder="姓名"
        maxlength="20"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        name="dataForm.sex"
        label="性别"
        :rules="[{ required: true, message: '请填写性别' }]"
      >
        <template #input>
          <van-radio-group v-model="dataForm.sex" direction="horizontal">
            <van-radio name="男">男</van-radio>
            <van-radio name="女">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        readonly
        clickable
        name="picker"
        :value="dataForm.schoolName"
        label="校区"
        placeholder="点击选择校区"
        @click="showSchoolPicker = true"
        :rules="[{ required: true, message: '请选择校区' }]"
      />

      <van-popup v-model="showSchoolPicker" position="bottom">
        <van-picker
          title="班级"
          :columns="searchSchoolColumns"
          confirm-button-text="确定"
          cancel-button-text="取消"
          :show-toolbar="true"
          @confirm="onConfirmSchool"
          @cancel="showSchoolPicker = false"
        >
          <template #title>
            <van-field
              style="width: 62%"
              v-model="searchSchoolKey"
              placeholder="请输入搜索内容"
              clearable
            />
          </template>
          <template #option="option">
            <div class="text-content">
              <span>{{ option.schoolName }}</span>
            </div>
          </template>
        </van-picker>
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="dataForm.className"
        label="班级"
        placeholder="点击选择班级"
        @click="showClassPicker = true"
        :rules="[{ required: true, message: '请选择班级' }]"
      />
      <van-popup v-model="showClassPicker" position="bottom">
        <van-picker
          title="班级"
          :columns="searchClassColumns"
          confirm-button-text="确定"
          cancel-button-text="取消"
          :show-toolbar="true"
          @confirm="onConfirmClass"
          @cancel="showClassPicker = false"
        >
          <template #title>
            <van-field
              style="width: 62%"
              v-model="searchClassKey"
              placeholder="请输入搜索内容"
              clearable
            />
          </template>
          <template #option="option">
            <div class="text-content">
              <span>{{ option.className }}</span>
            </div>
          </template>
        </van-picker>
      </van-popup>

      <van-field
        v-model="dataForm.tel"
        label="联系方式"
        placeholder="联系方式"
        maxlength="20"
        :rules="[{ required: true, message: '请填写联系方式' }]"
      />
      <van-field
        name="dataForm.fileList"
        label="上传简历"
        :rules="[{ required: true, message: '请上传简历' }]"
      >
        <template #input>
          <van-uploader
            :after-read="importFileSuccess"
            :before-delete="importFileRemove"
            :max-size="30 * 1024 * 1024"
            @oversize="onOversize"
            :max-count="1"
            accept=".pdf,.PDF"
            v-model="dataForm.fileList"
          >
            <template>
              <van-button type="info" size="small">上传</van-button>
            </template>
          </van-uploader>
        </template>
      </van-field>

      <div class="but-wrap">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
        <van-button class="cancle" round block plain type="info" @click="goBack"
          >取消</van-button
        >
      </div>
    </van-form>
    <!-- <el-form
      class="form"
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          maxlength="20"
          show-word-limit
          clearable
          v-model="dataForm.name"
          placeholder="姓名"
        ></el-input> </el-form-item
      ><el-form-item label="性别" prop="sex">
        <el-radio-group
          v-model="dataForm.sex"
          placeholder="请选择性别"
          filterable
          clearable
        >
          <el-radio label="男">男</el-radio>
          <el-radio label="女">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所属校区" prop="schoolId">
        <el-select
          style="width: 100%"
          v-model="dataForm.schoolId"
          placeholder="所属校区"
          clearable
          @change="schooolChange"
        >
          <el-option
            v-for="(item, index) in schoolList"
            :key="index"
            :label="item.schoolName"
            :value="item.schoolId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属班级" prop="classId">
        <el-select
          style="width: 100%"
          v-model="dataForm.classId"
          placeholder="所属班级"
          clearable
        >
          <el-option
            v-for="(item, index) in classList"
            :key="index"
            :label="item.className"
            :value="item.classId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系方式" prop="tel">
        <el-input type="number" v-model="dataForm.tel" placeholder="联系方式"></el-input>
      </el-form-item>
      <el-form-item prop="fileList" label="简历上传">
        <el-upload
          accept=".pdf,.PDF"
          :action="fileUrl"
          :limit="1"
          :file-list="dataForm.fileList"
          :on-remove="importFileRemove"
          :on-success="importFileSuccess"
          :before-upload="beforeFileUpload"
        >
          <el-button type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传一份pdf文件。建议以“岗位-姓名-联系方式”来命名pdf文件。
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-preventReClick v-waves @click="goBack">取消</el-button>
      <el-button
        v-preventReClick
        v-waves
        type="primary"
        @click="dataFormSubmit()"
        >确定</el-button
      >
    </span> -->
  </div>
</template>

<script>
import {
  schoolList,
  classList,
  saveResume,
  uploadResume,
  ossPolicy,
  ossUpload,
} from "@/api/common";
// import { isMobile } from "@/utils/validate";
export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (value != null && value != "" && !isMobile(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      schoolList: [],
      classList: [],
      dataForm: {
        id: 0,
        name: "",
        sex: "",
        tel: "",
        schoolId: null,
        schoolName: "",
        classId: null,
        className: "",
        fileList: [],
      },
      resumeName: "",
      fileUrl: "",

      showSchoolPicker: false,
      searchSchoolKey: "",
      searchSchoolColumns: [],
      showClassPicker: false,
      searchClassKey: "",
      searchClassColumns: [],
      dataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        action: "",
        expiration: null,
      },
      uploadUrlPre:"https://mhys-cloud-class.oss-cn-beijing.aliyuncs.com/jyglUpload/"
    };
  },
  watch: {
    searchSchoolKey() {
      let key = String(this.searchSchoolKey);
      key = key.replace(/\s*/g, ""); //去除搜索内容中的空格
      const reg = new RegExp(key, "ig"); //匹配规则-i：忽略大小写，g：全局匹配
      /* 进行筛选，将筛选后的数据放入新的数组中，‘name’键可根据需要搜索的key进行调整 */
      this.searchSchoolColumns = this.schoolList.filter(
        (item) => item.schoolName.match(reg) != null
      );
    },

    searchClassKey() {
      let key = String(this.searchClassKey);
      key = key.replace(/\s*/g, ""); //去除搜索内容中的空格
      const reg = new RegExp(key, "ig"); //匹配规则-i：忽略大小写，g：全局匹配
      /* 进行筛选，将筛选后的数据放入新的数组中，‘name’键可根据需要搜索的key进行调整 */
      this.searchClassColumns = this.classList.filter(
        (item) => item.className.match(reg) != null
      );
    },
  },
  mounted() {
    this.init(this.$route.query.id);
  },
  methods: {
    /**
     * @name: 点击选择文件-读取oss信息
     */
    selectFile() {
      ossPolicy().then(({ data }) => {
        if (data && data.code === 200) {
          let policyData = data.data;
          this.dataObj.policy = policyData.policy;
          this.dataObj.signature = policyData.signature;
          this.dataObj.ossaccessKeyId = policyData.accessid;
          this.dataObj.key = policyData.dir + "/" + getUUID() + "_${filename}";
          this.dataObj.dir = policyData.dir;
          this.dataObj.host = policyData.host;
          this.dataObj.action = policyData.host;
          this.dataObj.expiration = new Date(policyData.expire);
          this.dataObj.success_action_status = "201";
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    onOversize(file) {
      this.$toast("文件大小不能超过30M");
    },
    goBack() {
      this.$router.go(-1);
    },
    init(id) {
      this.dataObj.policy = "";
      this.dataObj.signature = "";
      this.dataObj.key = "";
      this.dataObj.ossaccessKeyId = "";
      this.dataObj.dir = "";
      this.dataObj.host = "";
      this.dataObj.action = "";
      this.dataObj.expiration = null;
      this.dataForm.id = id || 0;
      console.log("this.dataForm.id", this.dataForm.id);
      this.visible = true;
      this.$nextTick(() => {
        this.getSchoolList();
      });
    },
    /**
     * @name: 所有区域
     */

    getSchoolList() {
      schoolList().then(({ data }) => {
        if (data && data.code === 200) {
          this.schoolList = data.data;
          this.searchSchoolColumns = this.schoolList;
        }
      });
    },
    /**
     * @name: 校区的选择
     * @param {*} e
     */
    onConfirmSchool(e) {
      console.log(e);
      this.showSchoolPicker = !this.showSchoolPicker;
      this.dataForm.schoolName = e.schoolName;
      this.dataForm.schoolId = e.schoolId;
      // 班级的处理
      this.dataForm.classId = null;
      this.dataForm.className = "";
      this.getClassList(e.schoolId);
    },
    /**
     * @name: 校区下的班级
     */

    getClassList(id) {
      classList(id).then(({ data }) => {
        if (data && data.code === 200) {
          this.searchClassColumns = data.data;
          this.classList = this.searchClassColumns;
        }
      });
    },

    /**
     * @name: 班级的选择
     * @param {*} e
     */
    onConfirmClass(e) {
      this.showClassPicker = !this.showClassPicker;
      this.dataForm.className = e.className;
      this.dataForm.classId = e.classId;
    },
    // 表单提交
    dataFormSubmit() {
      console.log("this.dataForm.fileList[0]", this.dataForm.fileList[0]);
      if (this.dataForm.fileList.length == 0) {
        this.$message.error("请上传简历");
        return;
      }
      let params = {
        meetingPostId: this.dataForm.id || undefined,
        schoolId: this.dataForm.schoolId,
        classId: this.dataForm.classId,
        name: this.dataForm.name,
        sex: this.dataForm.sex,
        tel: this.dataForm.tel,
        resume: this.resumeName,
        resumePath: this.dataForm.fileList[0],
      };
      console.log("params", params);
      // return false;
      let a = {
        meetingPostId: this.dataForm.id || undefined,
        schoolId: this.dataForm.schoolId,
        classId: this.dataForm.classId,
        name: this.dataForm.name,
        sex: this.dataForm.sex,
        tel: this.dataForm.tel,
      };
      sessionStorage.setItem("applyData", JSON.stringify(a));
      // return false;
      saveResume(params).then(({ data }) => {
        if (data && data.code === 200) {
          this.$toast({
            message: "投递成功",
            type: "success",
            duration: 1500,
            onClose: () => {
              this.goBack();
            },
          });
        } else {
          this.$toast(data.msg);
        }
      });
    },
    importFileRemove(file, detail) {
      this.dataForm.fileList.splice(detail.index, 1);

      // let that = this;
      // console.log(file, detail);

      // this.$http
      //   .post(api.api_base + "/system/file/deleteFile", {
      //     ids: file.fileid || file.id
      //   })
      //   .then(res => {
      //     // console.log(res,'删除成功')
      //     that.fileList.splice(detail.index, 1);
      //     this.$toast({
      //       message: res.message
      //     });
      //   });
    },

    importFileSuccess(file) {
      console.log("file", file);
      console.log("type", file.file.type);
      this.resumeName = file.file.name;
      if (file.file.type != "application/pdf") {
        this.dataForm.fileList = [];
        this.$toast("请选择pdf文件格式进行上传");
        return false;
      }
      const toastId = this.$toast({
        type: "loading",
        message: "正在上传...",
        duration: 0,
        forbidClick: true,
      });
      ossPolicy().then(({ data }) => {
        this.$toast.clear(toastId);
        console.log("data", data);
        if (data && data.code === 200) {
          let policyData = data.data;
          var formData = new FormData();
          formData.append("policy", policyData.policy);
          formData.append("signature", policyData.signature);
          formData.append("ossaccessKeyId", policyData.accessid);
          formData.append("key",policyData.dir + "/" + this.getUUID() + "_${filename}");
          formData.append("dir", policyData.dir);
          formData.append("host", policyData.host);
          formData.append("action", policyData.host);
          formData.append("expiration", new Date(policyData.expire));
          formData.append("success_action_status", "201");
          formData.append("file", file.file);
          ossUpload(policyData.host, formData).then((response) => {
            if (response.data && response.data.indexOf("<Location>") != -1) {
              this.dataForm.fileList = [this.escape2Html(
                  response.data.substring(
                    response.data.indexOf("<Location>") +this.uploadUrlPre.length + 10,
                    response.data.indexOf("</Location>")
                  )
                )];
              // this.dataForm.fileList.push({
              //   name: this.resumeName,
              //   path: this.escape2Html(
              //     response.data.substring(
              //       response.data.indexOf("<Location>") + 10,
              //       response.data.indexOf("</Location>")
              //     )
              //   ),
              // });
              console.log("this.dataForm.fileList", this.dataForm.fileList);
            } else {
              // 有错误码
              //抛出异常信息,没有<Location>
              this.$toast.error("上传失败！");
              this.dataForm.fileList = [];
            }
          });
        } else {
          this.$toast(data.msg);
        }
      });

      // let that = this;
      // let params = new FormData();
      // params.append("file", file.file);
      // uploadResume(params).then(({ data }) => {
      //   this.$toast.clear(toastId);
      //   if (data && data.code === 200) {
      //     this.dataForm.fileList = [data.data];
      //   } else {
      //     this.dataForm.fileList = [];
      //     this.$toast(data.msg);
      //   }
      // });
    },

    escape2Html(str) {
      var temp = document.createElement("div");
      temp.innerHTML = str;
      var output = temp.innerText || temp.textContent;
      temp = null;
      return output;
    },
    /**
     * 获取uuid
     */
    getUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        return (c === "x"
          ? (Math.random() * 16) | 0
          : "r&0x3" | "0x8"
        ).toString(16);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.send-add-mobile {
  font-size: 16px;
  .form {
    padding: 20px 20px 60px;
    .el-button {
      height: 40px;
      padding: 0 20px;
    }
    .el-upload__tip {
      font-size: 14px;
    }
  }
  .dialog-footer {
    position: fixed;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    background: #fff;
    border-top: 1px solid #e8e8e8;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      width: 100%;
      border: 0;
      border-radius: 0;
      height: 50px;
      font-size: 18px;
    }
  }
  .but-wrap {
    margin: 1rem 0.3rem;
    .cancle {
      margin-top: 0.3rem;
    }
  }
  .text-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>

<style lang="scss">
$--color-primary: #266eff;
.send-add-mobile {
  .el-form-item__label,
  .el-input__inner,
  .el-radio__label {
    font-size: 16px;
  }
  .van-picker__confirm {
    color: $--color-primary;
  }
}
</style>
